import { appConstants } from '../../../constants'

const initialState = {
  articleDetail: {},
  loading: false,
  error: null
}

export const reducerDetailArticle = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.DETAIL_ARTICLE_SUCCESS :
      return {
        ...state,
        loading: false,
        error: null,
        articleDetail: { ...action.payload.detailArticle }
      }
    case appConstants.DETAIL_ARTICLE_REQUEST :
      return {
        ...state,
        loading: !state.loading,
        error: null,
        articleDetail: {}
      }
    case appConstants.DETAIL_ARTICLE_FAILED :
      return {
        ...state,
        error: { ...action.payload.message },
        articleDetail: {}
      }
    default:
      return state
  }
}
